import get from 'lodash/get';

const sortByKey = (list, key) =>
  list?.sort((a, b) => get(a, key)?.localeCompare(get(b, key)));

export default sortByKey;
